import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="min-h-screen bg-white flex flex-col">
      <div className="flex-1 flex items-center justify-center px-6 py-20">
        <div className="max-w-2xl mx-auto text-center">
          <h1 className="text-[10rem] md:text-[14rem] font-bold leading-none tracking-tighter text-gray-100 select-none">
            404
          </h1>
          <h2 className="text-3xl md:text-4xl font-serif font-semibold text-primary-dark -mt-16 md:-mt-20 mb-4">
            Page Not Found
          </h2>
          <p className="text-gray-500 text-lg mb-10 max-w-md mx-auto leading-relaxed">
            The page you're looking for doesn't exist or has been moved.
            Let's get you back on track.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/"
              className="inline-flex items-center px-8 py-4 bg-primary-orange text-white font-bold rounded-full hover:bg-primary-dark transition-all duration-300 shadow-lg shadow-primary-orange/20"
            >
              <i className="ri-home-line mr-2"></i>
              Back to Home
            </Link>
            <Link
              to="/contact"
              className="inline-flex items-center px-8 py-4 bg-white text-primary-dark font-bold rounded-full border-2 border-gray-200 hover:border-primary-orange hover:text-primary-orange transition-all duration-300"
            >
              <i className="ri-mail-line mr-2"></i>
              Contact Us
            </Link>
          </div>
          <div className="mt-16 pt-10 border-t border-gray-100">
            <p className="text-sm text-gray-400 uppercase tracking-widest font-semibold mb-6">Quick Links</p>
            <div className="flex flex-wrap justify-center gap-6 text-sm">
              <Link to="/services" className="text-gray-500 hover:text-primary-orange transition-colors font-medium">Our Services</Link>
              <Link to="/about" className="text-gray-500 hover:text-primary-orange transition-colors font-medium">About Us</Link>
              <Link to="/insights" className="text-gray-500 hover:text-primary-orange transition-colors font-medium">Insights</Link>
              <Link to="/testimonials" className="text-gray-500 hover:text-primary-orange transition-colors font-medium">Testimonials</Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
